import { useState, useEffect, useCallback } from 'react'

// เลียนแบบพฤติกรรม sync ของ @rehooks/local-storage (useLocalStorage/writeStorage/
// deleteFromStorage) แต่ผูกกับ sessionStorage แทน - library เดิมไม่มี sessionStorage
// variant ให้ใช้ (ดู pii-remediation-summary.md Ref 4)
//
// จำเป็นต้องมี pub-sub นี้ เพราะถ้าใช้ useState เฉยๆ แต่ละ component ที่อ่าน key
// เดียวกัน (เช่น ListRegister กับ AddList) จะถือ state แยกกันไม่ sync กัน ทำให้
// component ที่ถือ state เก่ากว่าเขียนทับข้อมูลที่อีก component เพิ่งแก้ไปได้
// (เจอจริง: ลบรายชื่อใน ListRegister แล้วกด "เพิ่มรายชื่อ" ใน AddList คนที่ลบไปแล้ว
// กลับมาใหม่ เพราะ AddList ยังถือ state เก่าตอน mount อยู่)
const listeners = {}

const notify = (key, value) => {
  const keyListeners = listeners[key] || []
  keyListeners.forEach((fn) => fn(value))
}

const read = (key) => {
  try {
    return JSON.parse(sessionStorage.getItem(key))
  } catch {
    return undefined
  }
}

export const writeSessionStorage = (key, value) => {
  sessionStorage.setItem(key, JSON.stringify(value))
  notify(key, value)
}

export const deleteFromSessionStorage = (key) => {
  sessionStorage.removeItem(key)
  notify(key, undefined)
}

export const useSessionStorage = (key) => {
  const [value, setValue] = useState(() => read(key))

  useEffect(() => {
    const listener = (newValue) => setValue(newValue)
    listeners[key] = listeners[key] || []
    listeners[key].push(listener)
    return () => {
      listeners[key] = (listeners[key] || []).filter((fn) => fn !== listener)
    }
  }, [key])

  const setter = useCallback((newValue) => writeSessionStorage(key, newValue), [
    key,
  ])

  return [value, setter]
}

export default useSessionStorage
